var generic = generic || {};
var site = site || {};

(function ($) {
  site.emailSignupPromoUK = {
    templateContainer: $(),

    initEmailSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var $emailContainerNode = $(this);
        var $emailForm = $emailContainerNode.is('form') ? $emailContainerNode : $('form', $emailContainerNode);
        var $emailSuccess = $('.email-signup__success', $emailContainerNode);
        var $emailError = $('.email-signup__error', $emailContainerNode);
        var $emailErrorTicked = $('.email-signup__error-ticked', $emailContainerNode);
        var $emailInput = $('input[name="PC_EMAIL_ADDRESS"]', $emailContainerNode);

        $("input[type='checkbox']").change(function () {
          $('input[name=PC_EMAIL_PROMOTIONS]', $emailContainerNode).val(this.checked ? 1 : 0);
        });

        $emailForm.once('email-signup__form').submit(function (submitEvt) {
          submitEvt.preventDefault();
          $emailSuccess.add($emailError).addClass('hidden');
          $emailInput.removeClass('error');
          $emailErrorTicked.addClass('hidden');

          // Transform string into array of form elements
          var params = {};

          $.each($emailForm.serializeArray(), function (index, kv) {
            params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
          });

          // Send the data via a json rpc call
          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [params],
            onSuccess: function (jsonRpcResponse) {
          	$('.email-signup-promo__success').removeClass('hidden');
          	$('#email-signup__form').addClass('hidden');
          	$('.email-signup-promo__copy').addClass('hidden');
            },
            onFailure: function (jsonRpcResponse) {
              $emailError.removeClass('hidden');
              $emailInput.addClass('error');
            }
          });
        });
      });
    }
  };

  Drupal.behaviors.emailSignupPromoFormUKV1 = {
    attach: function (context, settings) {
      site.emailSignupPromoUK.templateContainer = $('.email-signup-promo-uk', context);
      site.emailSignupPromoUK.initEmailSignup();
    }
  };
})(jQuery);
